/**
 * A compact "current position" chip: the station number in a pill coloured by
 * the station's transport type (underground = red, bus = blue, taxi = yellow),
 * followed by the transport-type icons available there. Lets a player read
 * their stop's type without it being hidden under the pawn on the map.
 */

import { Group, Text } from '@mantine/core'
import { TransportIcon } from './TransportIcon'
import { stationColor, stationTransports } from './stationTransports'

interface Props {
  station: number | null
  size?: 'sm' | 'md'
}

export function PositionChip( { station, size = 'md' }: Props ) {
  if ( station == null ) return null
  const transports = stationTransports( station )
  // Pill colour = the station's dominant tier — same convention the board uses.
  const pillColor = stationColor( station )
  const fontSize = size === 'sm' ? 12 : 15
  const iconSize = size === 'sm' ? 14 : 18
  return (
    <Group
      gap={ 6 }
      wrap="nowrap"
      align="center"
    >
      <Text
        span
        fw={ 800 }
        style={ {
          background: pillColor,
          color: '#fff',
          borderRadius: 999,
          padding: size === 'sm' ? '1px 8px' : '2px 11px',
          fontSize,
          lineHeight: 1.5,
          whiteSpace: 'nowrap',
        } }
      >
        #{ station }
      </Text>
      { transports.length > 0 && (
        <Group
          gap={ 3 }
          wrap="nowrap"
        >
          { transports.map( ( t ) => (
            <TransportIcon
              key={ t }
              transport={ t }
              size={ iconSize }
            />
          ) ) }
        </Group>
      ) }
    </Group>
  )
}
